import { Grid, InputAdornment } from '@mui/material';
import RHFTextField from '../../../../components/hook-form/RHFTextField';
import AcceptOrRejectWithQuestionsWithReason from '../AcceptOrRejectWithQuestionsWithReason';
import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';

const FormInputString = ({ name, data, disabled, index, refetch, withGridBox, gridSize, ...props }) => {

  const [hidden, setHidden] = useState(false);

  const { control, watch, setValue } = useFormContext();

  let watchParent;
  if (data?.options?.parentId) watchParent = watch(`${data?.options?.parentId}`);

  useEffect(() => {
    if (!watchParent) return;
    const afterChangeParent = data?.options?.afterChangeParent;
    if (afterChangeParent) {
      const is = watchParent?.value === afterChangeParent.on;
      if (afterChangeParent.by === 'child') {
        if (is) {
          if (afterChangeParent.type === 'resetChilds') setValue(name, null);
          if (data?.options?.afterChangeParent?.withHidden && !hidden) setHidden(true);
        } else if (data?.options?.afterChangeParent?.withHidden && hidden) setHidden(false);
      }
    }
  }, [watchParent]);
  if (hidden) return <></>;
  return (
    withGridBox ?
      <Grid item {...gridSize}>
        <RHFTextField
          name={name}
          label={data?.label}
          disabled={disabled}
          required={data?.options?.required}
          InputProps={{
            autoComplete: 'off',
            ...(data?.need_confirm // && isHistory
              ? {
                endAdornment: (
                  <InputAdornment
                    position="start"
                    sx={{
                      display: 'flex',
                      gap: 1,
                    }}
                  >
                    <AcceptOrRejectWithQuestionsWithReason
                      {...data?.client_inputs?.[index || 0]}
                      history={data?.old_client_inputs?.[index || 0]}
                      type={data?.type}
                      refetch={refetch}
                    />
                  </InputAdornment>
                ),
              }
              : {}),
          }}
          {...props}
          {...data?.options?.inputProps}
        />
      </Grid>
      :
      <RHFTextField
        name={name}
        label={data?.label}
        disabled={disabled}
        required={data?.options?.required}
        InputProps={{
          autoComplete: 'off',
          ...(data?.need_confirm // && isHistory
            ? {
              endAdornment: (
                <InputAdornment
                  position="start"
                  sx={{
                    display: 'flex',
                    gap: 1,
                  }}
                >
                  <AcceptOrRejectWithQuestionsWithReason
                    {...data?.client_inputs?.[index || 0]}
                    history={data?.old_client_inputs?.[index || 0]}
                    type={data?.type}
                    refetch={refetch}
                  />
                </InputAdornment>
              ),
            }
            : {}),
        }}
        {...props}
        {...data?.options?.inputProps}
      />
  );
};

export default FormInputString;
